import { useCallback } from 'react';
import { QueryFunctionContext } from '@tanstack/react-query';
import { useAuthFetch } from '@cko/dashboard-shared';
import qs from 'query-string';

export const useGetIntelligentAcceptanceAvailabilityFetcher = () => {
  const fetch = useAuthFetch();

  return useCallback(
    async ({ queryKey }: QueryFunctionContext) => {
      const [path, { clientId }] = queryKey as [string, { clientId: string }];

      const params = qs.stringify({
        clientId,
      });

      const response = await fetch(`${path}?${params}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      const data = await response.json();
      return Boolean(data.is_activated || data.is_eligible);
    },
    [fetch],
  );
};
